/**
 * Tooltip — shadcn Tooltip 어댑터. 기존 content/position/children API 유지.
 *
 * TooltipProvider를 어댑터 내부에서 자체 래핑해
 * 앱 루트를 수정하지 않고도 동작한다.
 * position prop → shadcn의 side prop으로 매핑.
 */

import { ReactNode } from 'react'
import {
  Tooltip as ShadTooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from '@/components/ui/tooltip'
import { cn } from './cn'

interface TooltipProps {
  /** 툴팁에 표시할 내용 */
  content: ReactNode
  /** 툴팁 표시 위치. 기본값 top */
  position?: 'top' | 'bottom' | 'left' | 'right'
  /** 툴팁을 트리거할 자식 요소 */
  children: ReactNode
  className?: string
}

export function Tooltip({
  content,
  position = 'top',
  children,
  className,
}: TooltipProps) {
  return (
    <TooltipProvider>
      <ShadTooltip>
        <TooltipTrigger asChild className={cn(className)}>
          {/* 단일 자식 요소를 그대로 트리거로 사용 */}
          <span>{children}</span>
        </TooltipTrigger>
        <TooltipContent side={position}>
          {content}
        </TooltipContent>
      </ShadTooltip>
    </TooltipProvider>
  )
}
